import { agentsGainedTooltips as plt } from '../../../../agent-production/agent-movement/constants';
import { getAdditionalTableHeader } from '../agGrid/agGrid';
import { cellRenderers } from '../agGrid/tableViews';

const agentsGainedBreakdown = (id, { colSettings: cs }, shouldShowAdditionalInfo) => ({
    id,
    defaultSort: { colId: plt.agentName.keyField, sortDir: 'desc' },
    tables: [
        {
            headerGroupTitle: (props) => getAdditionalTableHeader('agentInformation', props),
            children: [
                {
                    col: { ...plt.agentName, isDisplayed: true },
                    colDef: cs.textMd,
                    cellRenderer: cellRenderers.agentNameLink
                },
                { col: { ...plt.officeId, isDisplayed: shouldShowAdditionalInfo }, colDef: cs.textSm },
                { col: { ...plt.officeName, isDisplayed: shouldShowAdditionalInfo}, colDef: cs.textSm },
                { col: { ...plt.officeStreetName, isDisplayed: shouldShowAdditionalInfo}, colDef: cs.textMd },
                { col: { ...plt.officeCity, isDisplayed: shouldShowAdditionalInfo}, colDef: cs.textSm },
                { col: { ...plt.officeZipCode, isDisplayed: shouldShowAdditionalInfo}, colDef: cs.textXs },
                { col: { ...plt.agentPhone1, isDisplayed: shouldShowAdditionalInfo}, colDef: cs.textMd },
                { col: { ...plt.agentPhone2, isDisplayed: shouldShowAdditionalInfo}, colDef: cs.textMd },
                { col: { ...plt.agentPhone3, isDisplayed: shouldShowAdditionalInfo}, colDef: cs.textMd },
                { col: { ...plt.agentEmail, isDisplayed: shouldShowAdditionalInfo}, colDef: cs.textMd },
                { col: { ...plt.agentStreetName, isDisplayed: shouldShowAdditionalInfo}, colDef: cs.textMd },
                { col: { ...plt.agentCity, isDisplayed: shouldShowAdditionalInfo}, colDef: cs.textSm },
                { col: { ...plt.agentZipCode, isDisplayed: shouldShowAdditionalInfo}, colDef: cs.textSm },
                { col: { ...plt.moveDate, isDisplayed: true}, colDef: cs.dateSm }
            ]
        },
        {
            headerGroupTitle: (props) => getAdditionalTableHeader('beforeMove', props),
            children: [{ col: { ...plt.volumePreMove, isDisplayed: true }, colDef: cs.numberSmInteger }]
        },
        {
            headerGroupTitle: (props) => getAdditionalTableHeader('afterMove', props),
            children: [
                { col: { ...plt.daysSinceMove, isDisplayed: true }, colDef: cs.numberSmInteger },
                { col: { ...plt.percentOf365DaysWithOffice, isDisplayed: true }, colDef: cs.numberSmPercentageMultiplier },
                { col: { ...plt.volumePostMove, isDisplayed: true }, colDef: cs.numberSmInteger },
                { col: { ...plt.volumeYardstick, isDisplayed: true }, colDef: cs.numberMdInteger },
                { col: { ...plt.volumeDifference, isDisplayed: true }, colDef: cs.numberSmInteger },
                { col: { ...plt.volumeGrowth, isDisplayed: true }, colDef: cs.numberSmPercentageMultiplier }
            ]
        }
    ]
});

export default agentsGainedBreakdown;
